import { useContext } from 'react';
import ABeagleContext from '../../contexts/abeagle';

const AD_INJECTION_EXPERIMENT = 'RT-2202-ad-injection-card-style-quiz';

/**
 * Hook to determine ad eligibility for card style quizzes.
 * Centralizes the logic for inline/interstitial ad eligibility based on
 * the ad injection experiment.
 *
 * @param {Object} buzz - The buzz object containing quiz type info
 * @returns {Object} - { isInlineAdEligible, isInterstitialAdEligible }
 */
export function useCardStyleAdEligibility(buzz) {
  const { experiments, getExperimentValue } = useContext(ABeagleContext);

  const adInjectionVariant = experiments?.loaded
    ? getExperimentValue(AD_INJECTION_EXPERIMENT, { rejectErrors: false })
    : null;

  return {
    isInlineAdEligible: adInjectionVariant === 'v1', // 'inline_ad',
    isInterstitialAdEligible: adInjectionVariant === 'v2', // 'interstitial_ad',
    isInlineAndInterstitialAdEligible: adInjectionVariant === 'v3', // 'inline_interstitial_ad',
  };
}

export default useCardStyleAdEligibility;
